export default __webpack_public_path__ + "static/media/addEmployee.c4704177.png";